import {ExperimentNames, getBuyerTotal} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useExperiments, usePanorama} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {FormStep} from '../../../constants'
import c from '../../classnames.scss'
import {FormButton} from '../../form-button/form-button'
import {FormSteps} from '../../form-steps'
import {Step} from '../../form-steps/interfaces'
import {Checkout} from '../index'
import {ReservationTimer} from '../reservation-timer'
import {CheckoutSummary} from './checkout-summary'
import {MobileCheckoutProps} from './interfaces'
import s from './mobile-checkout.scss'

export const MobileCheckout = ({
  formPageLoaded,
  closeNativeModal,
  openTicketsDetailsModal,
  reservationExpiration,
  invoice,
  giftCardPaymentDetails,
  t,
  openTimeExpiredModal,
  scrollToElement,
}: MobileCheckoutProps) => {
  const {logger} = usePanorama()
  const buyerTotal = getBuyerTotal(invoice.grandTotal, giftCardPaymentDetails)
  const {isMobile} = useEnvironment()
  const {experiments} = useExperiments()

  useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()
  }, [formPageLoaded, closeNativeModal])

  const isCheckoutReady = (steps: Step[]) => steps.every(step => step.completed)

  const openTicketDetails = () => openTicketsDetailsModal()

  return (
    <Checkout
      t={t}
      logger={logger}
      isMobile={isMobile}
      disabledButtonEnabled={experiments.enabled(ExperimentNames.DisabledButtonsViewer)}
    >
      {(steps: Step[], currentStep: FormStep, pay: Function) => (
        <div className={classNames(s.container, c.formBackgroundColor)}>
          <div className={s.stack}>
            <ReservationTimer
              expires={reservationExpiration}
              onExpire={openTimeExpiredModal}
              t={t}
              isMobile={isMobile}
            />
            <CheckoutSummary onViewAllItems={openTicketDetails} currentStep={currentStep} buyerTotal={buyerTotal} />
          </div>
          <FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />
          {isCheckoutReady(steps) && Number(buyerTotal.amount) > 0 ? (
            <div className={s.button}>
              <FormButton
                text={t('mobile.checkout.placeOrder')}
                type="submit"
                dataHook={DH.CHECKOUT_BUTTON}
                onClick={pay}
              />
            </div>
          ) : null}
        </div>
      )}
    </Checkout>
  )
}
